var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.00016 0.607422C3.32016 0.607422 0.333496 3.59409 0.333496 7.27409C0.333496 10.9541 3.32016 13.9408 7.00016 13.9408C10.6802 13.9408 13.6668 10.9541 13.6668 7.27409C13.6668 3.59409 10.6802 0.607422 7.00016 0.607422ZM6.3335 12.5608C3.70016 12.2341 1.66683 9.99409 1.66683 7.27409C1.66683 6.86076 1.72016 6.46742 1.80683 6.08076L5.00016 9.27409V9.94076C5.00016 10.6741 5.60016 11.2741 6.3335 11.2741V12.5608ZM10.9335 10.8674C10.7602 10.3274 10.2668 9.94076 9.66683 9.94076H9.00016V7.94076C9.00016 7.57409 8.70016 7.27409 8.3335 7.27409H4.3335V5.94076H5.66683C6.0335 5.94076 6.3335 5.64076 6.3335 5.27409V3.94076H7.66683C8.40016 3.94076 9.00016 3.34076 9.00016 2.60742V2.33409C10.9535 3.12742 12.3335 5.04076 12.3335 7.27409C12.3335 8.66076 11.8002 9.92076 10.9335 10.8674Z",
    fill: "#2D96B4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeIcon);
export default __webpack_public_path__ + "static/media/GlobeIcon.2b5839f0.svg";
export { ForwardRef as ReactComponent };